var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup68129(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_148243",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68129",
    "data-name": "Group 68129",
    transform: "translate(-1684 -175)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1684, 175)",
    filter: "url(#Rectangle_148243)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148243-2",
    "data-name": "Rectangle 148243",
    width: 46,
    height: 46,
    rx: 10,
    transform: "translate(9 7)",
    fill: "#0267c1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "microsoftexcel",
    transform: "translate(1704.571 192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44874",
    "data-name": "Path 44874",
    d: "M21.9,3a.893.893,0,0,1,.667.286.893.893,0,0,1,.286.667v18.1A.976.976,0,0,1,21.9,23H6.667a.976.976,0,0,1-.952-.952V18.714H.952a.893.893,0,0,1-.667-.286A.893.893,0,0,1,0,17.762V8.238a.893.893,0,0,1,.286-.667.874.874,0,0,1,.667-.286H5.714V3.952A.893.893,0,0,1,6,3.286.893.893,0,0,1,6.667,3ZM5.714,14.219l1.352,2.533H9.1L6.838,13.067,9.067,9.448H7.1L5.867,11.733l-.048.076-.038.086-.61-1.219L4.543,9.448H2.467l2.162,3.638L2.267,16.752H4.324Zm7.857,7.352V18.714H7.143v2.857Zm0-4.286V13.714H11.429v3.571Zm0-5V8.714H11.429v3.571Zm0-5V4.429H7.143V7.286Zm7.857,14.286V18.714H15v2.857Zm0-4.286V13.714H15v3.571Zm0-5V8.714H15v3.571Zm0-5V4.429H15V7.286Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup68129);
export default __webpack_public_path__ + "static/media/Group 68129.3ec6ac95d360eb758e209bd3793932ab.svg";
export { ForwardRef as ReactComponent };